import 'url-search-params-polyfill';

export function createSearchParams(init) {
  return new URLSearchParams(
    typeof init === 'string' ||
    Array.isArray(init) ||
    init instanceof URLSearchParams
      ? init
      : Object.keys(init).reduce((memo, key) => {
          let value = init[key];
          return memo.concat(
            Array.isArray(value) ? value.map(v => [key, v]) : [[key, value]]
          );
        }, [])
  );
}

const defaultEncoder = (schema, params) => {
  return schema.stripDefaults().encode(params) || {};
};

const defaultDecoder = (schema, params) => {
  return schema.decode(params) || {};
};

export default class SearchParams {
  constructor(schema) {
    this._schema = schema;
    this._encoder = defaultEncoder;
    this._decoder = defaultDecoder;
  }

  encoder(encoder) {
    this._encoder = encoder;
    return this;
  }

  decoder(decoder) {
    this._decoder = decoder;
    return this;
  }

  stringify(params) {
    const searchParams = createSearchParams(
      this._encoder(this._schema, params) || {}
    );

    const search = searchParams.toString();
    if (!search) {
      return '';
    }

    return `?${search}`.replace(/%7E/g, '~').replace(/%3A/g, ':');
  }

  validate(params) {
    const errorsSet = new Set();
    try {
      this._schema.validateSync(params, {
        abortEarly: false,
        context: {},
      });
    } catch (yupError) {
      if (yupError.inner.length === 0) {
        errorsSet.add(yupError.message);
      } else {
        yupError.inner.forEach(err => {
          errorsSet.add(err.message);
        });
      }
    }

    return Array.from(errorsSet);
  }

  parse(search) {
    const searchParams = createSearchParams(search);
    const params = Array.from(searchParams).reduce(
      (m, [k, v]) => ({ ...m, [k]: v }),
      {}
    );

    return this._decoder(this._schema, params) || {};
  }
}
